import { render, staticRenderFns } from "./StarVideoPage.vue?vue&type=template&id=1a7953f2&scoped=true&"
import script from "./StarVideoPage.vue?vue&type=script&lang=js&"
export * from "./StarVideoPage.vue?vue&type=script&lang=js&"
import style0 from "./StarVideoPage.vue?vue&type=style&index=0&id=1a7953f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7953f2",
  null
  
)

export default component.exports